export default __webpack_public_path__ + "static/media/map_innovation_leaders.d313008d.png";